import type { NarrativeConfig } from './NarrativeDirector';

/**
 * Arc 0 narrator lines. Style note: the blob starts pre-verbal, so
 * these are fragmentary, sensory, instinct-first. They evolve toward
 * coherence naturally because the player *reads* them in more
 * coherent shapes as they accrete. The Tootsie-Pop beat on first
 * cockroach is earned — the line is nonsense until the player gets
 * the reference, same as any good dumb joke.
 */
export const UNDERCITY_NARRATIVE: NarrativeConfig = {
  firstConsumeLines: {
    sludge: '[warm. wet. acceptable.]',
    mold: '[a new texture. fuzzy. gone.]',
    decay_pile: '[rich. rotten. yes.]',
    corpse_small: '[crunch on the inside. a surprise.]',
    corpse_medium: '[more crunch. more center.]',
    carcass: '[the shape of another. folded inward.]',
    cockroach: '[crunch. soft. crunch. three and the center is reached.]',
    larva: '[soft all the way through. no center.]',
    rat: '[this one ran. now does not.]',
    cat: '[was quick. is now still.]',
    alligator: '[a threat. removed.]',
    book: '[thin. flat. dry. there were shapes inside. they are inside me now.]',
  },
  firstCategoryLines: {
    skeletal: '[hard. then soft. then hard again. a pattern.]',
    exoskeletal: '[crunch first. softer within. I will remember this.]',
    fungal: '[a thing that grew. a thing I grew on.]',
    mammal: '[warm-blooded. cooling.]',
    reptile: '[cold-blooded. colder.]',
    living: '[it moved. then stopped. I was the reason.]',
    predator: '[was hunting. was.]',
    apex: '[the biggest one in here. was.]',
  },
  countLines: {
    cockroach: [
      { at: 5, line: '[they multiply faster than I consume.]' },
      { at: 15, line: '[every one identical. I find this soothing.]' },
    ],
    sludge: [
      { at: 10, line: '[I have tasted every puddle in this room.]' },
    ],
    decay_pile: [
      { at: 6, line: '[the rot is becoming me. the me is becoming rot.]' },
    ],
    mold: [
      { at: 8, line: '[I think the walls used to be alive.]' },
    ],
    book: [
      { at: 2, line: '[the shapes are starting to repeat. I know this one.]' },
      { at: 4, line: '[a word. I have a word. I do not know what it means.]' },
    ],
  },
};
